import _ from "lodash";
import store from "CommonState/store";
import {
  Component,
} from "react";
import {
  Alert,
  Button,
  Col,
  Row,
  Table,
} from "react-bootstrap";
import {
  Awesome,
  Panel,
  Spinner,
  Tooltip,
} from "CommonComponents/bricks";
import {
  formatDateTime,
} from "CommonCore/l10n";
import Dropzone from "react-dropzone";
import apifetch, {
  getApiHeaders,
} from "CommonCore/apifetch";
import Confirmation from "CommonComponents/confirmation";

const MAX_UPLOAD_SIZE = 200 * 1024 * 1024; // 200 MB

export default
@store("user")
class DokumentGruppeWidget extends Component {
  // Widget zur Anzeige von Dokumentgruppen
  constructor() {
    super();
    this.state = { added: false, addMode: false };
  }
  render() {
    const { items, name, notation } = this.props;
    const { addMode, deleteFile, deleteErrorMessage } = this.state;

    const sorted = _.sortBy(items, i => i.dok_dateiname);

    const DeletePopup = ({ file, onClose, onConfirm, deleteErrorMessage }) => {
      return <Confirmation
        header='Anlage entfernen'
        body={`Sind sie sicher, dass Sie die Anlage '${ file.dok_dateiname }' entfernen möchten? `}
        action='Entfernen'
        actionStyle='primary'
        onCancel={onClose}
        onConfirm={onConfirm}
        errorMessage={deleteErrorMessage}
      />;
    };

    return <Panel>

      {deleteFile && <DeletePopup file={deleteFile} onConfirm={this.onDelete} onClose={() => this.setState({ deleteFile: null, deleteErrorMessage: null })} errorMessage={deleteErrorMessage} />}

      <Row>
        <Col sm={12}>
          <h4>{name}</h4>
          <h5>{notation}</h5>

          {sorted.filter(item => item.b_id).length > 0 &&
            <Table width='100%' striped>
              <thead><tr>
                <th width='50%'>Dateiname</th>
                <th width='30%'>Datum</th>
                <th>Aktionen</th></tr>
              </thead>
              <tbody>
                {_.map(sorted, (item, i) => <tr key={i}><td style={{ verticalAlign: "middle" }}><Tooltip overlay='Anlage herunterladen'><a data-id={item.dok_id} data-message={item.url_download} onClick={this.handleDownload}>{item.dok_dateiname}</a></Tooltip></td>
                  <td style={{ verticalAlign: "middle" }}>{formatDateTime(item.datum)}</td>
                  <td>
                    <Tooltip overlay='Anlage herunterladen'><Button variant='outline-primary' data-message={item.url_download} onClick={this.handleDownload}><Awesome name='download' /></Button></Tooltip>
                    <Tooltip overlay='Anlage entfernen'><Button variant='outline-primary' style={{ marginLeft: "0.5em" }} onClick={this.beforeDelete} data-id={item.dol_dokid}><Awesome name='trash' /></Button></Tooltip>
                  </td>
                </tr>)}
              </tbody>
            </Table>
          }
          {!addMode && <Button variant='outline-primary' className='float-end' onClick={() => this.setState({ addMode: true })}><Awesome name='plus' />{`\u00a0`}<Tooltip overlay={name ? `Anlage vom Typ '${ name }' hinzufügen` : "Zusätzliche Anlage hinzufügen"}>Anlage hinzufügen</Tooltip></Button>}

          {addMode && <UploadContainer {...this.props} onCancel={() => this.setState({ addMode: false })} onOk={this.uploadOk} />}
        </Col>

      </Row>

    </Panel>;
  }
  handleDownload = e => {
    const { user } = this.props;
    const url = e.currentTarget.getAttribute("data-message");
    window.open(`/api/${ url }?token=${ user.token }`);
  };

  beforeDelete = e => {
    const { items } = this.props;
    const id = e.currentTarget.getAttribute("data-id");
    this.setState({ deleteFile: items.find(f => f.dol_dokid == id) });
  };

  onDelete = async() => {
    try {
      await apifetch(`/api/shkantrag/dokument/${ this.state.deleteFile.dol_dokid }`, { method: "DELETE" });
      this.setState({ deleteErrorMessage: null, deleteFile: null });
      this.props.afterUpload && this.props.afterUpload();
    } catch(err) {
      this.setState({ deleteErrorMessage: "Fehler beim Entfernen der Anlage" });
    }
  };


  uploadOk = () => {
    this.setState({ addMode: false });
    this.props.afterUpload && this.props.afterUpload();
  };
}

@store("user")
class UploadContainer extends Component {
  // Container für Dropzone und Fortschrittsanzeige

  constructor() {
    super();
    this.state = { files: [], uploading: false };
  }

  render() {
    const { files, errorMessage, uploading } = this.state;

    return <Row>
      <Col md={6}>
        <Dropzone accept={{ "application/pdf": [".pdf"] }} onDrop={this.handleDrop}>
          {({ getRootProps, getInputProps }) => (
            <section>
              <div style={{ padding: "1em", textAlign: "center", borderRadius: "6", border: "2px dashed grey" }} {...getRootProps()}>
                <input {...getInputProps()} />
                Klicken Sie in dieses Feld um PDF-Dateien auszuwählen <br /><br /> oder <br /><br /> legen Sie PDF-Dateien hier ab (Drag/Drop)<br /><br /><b>Alle Dateien insgesamt dürfen ein Volumen von 200 MB nicht überschreiten</b>
              </div>
            </section>
          )}
        </Dropzone>
      </Col>
      <Col md={6}>
        Liste der hochzuladenden Dateien

        <Table width='100%' striped>
          <thead><tr>
            <th width='50%'>Dateiname</th>
            <th width='30%'>Datum</th>
          </tr>
          </thead>
          <tbody>
            {_.map(files, (file, i) => <tr key={i}><td style={{ verticalAlign: "middle" }}>{file.name}</td>
              <td style={{ verticalAlign: "middle" }}>{formatDateTime(file.lastModifiedDate)}</td>
            </tr>)}
          </tbody>
        </Table>

        <Button disabled={!files || !files.length || uploading} variant='primary' style={{ marginRight: "0.5em" }} onClick={this.handleUpload}>Hochladen</Button>
        <Button variant='outline-primary' disabled={uploading} onClick={this.props.onCancel}>Abbrechen</Button>

        {errorMessage && <Alert variant='error'>{errorMessage}</Alert>}

        {uploading && <Spinner />}

      </Col>
    </Row>;
  }

  handleDrop = acceptedFiles => {
    let { files } = this.state;
    if (acceptedFiles) {
      const zuGross = acceptedFiles.find(f => f.size > MAX_UPLOAD_SIZE);
      if (zuGross) {
        this.setState({ errorMessage: `Datei '${ zuGross.name }' ist zu groß, maximal 200 MB erlaubt` });
        return;
      }
      // Nur unbekannte Dateien anhängen
      const newfiles = acceptedFiles.filter(n => !files.find(old => old.name == n.name));
      files = files.concat(newfiles);
    }
    this.setState({ files, errorMessage: undefined });
  };

  handleUpload = async() => {
    // Neue Anhänge hochladen
    this.setState({ uploading: true });

    // Post-Daten vorbereiten
    const data = new FormData();
    _.map(this.state.files, file => data.append("file", file));

    _.map(Object.keys(this.props.params).filter(k => k != "dok_id" && k != "b_id"), key => data.append(key, this.props.params[key]));

    const opts = { method: "POST" };

    opts.body = data;

    const headers = opts.headers || (opts.headers = {});
    _.assign(headers, getApiHeaders());

    try {
      const response = await fetch(`/api/${ this.props.urlupload || "shkantrag/dokument/upload/" }`, opts);
      if (response.ok) {
        this.props.onOk && this.props.onOk();
        this.setState({ uploading: false });
      } else {
        let um;
        try {
          um = (await response.json()).um;
        } catch(e) {
          // Antwort war kein JSON (z.B. Proxy-Fehlerseite)
        }
        this.setState({ uploading: false, errorMessage: `Fehler beim Hochladen: ${ um || response.statusText }` });
      }
    } catch(err) {
      // Harter Netzwerkfehler
      this.setState({ uploading: false, errorMessage: "Fehler beim Hochladen" });
    }
  };
}
